<template>
    <DefaultLayout>
        <div v-if="!busy"><br>
            <div class="row">
                <div class="col-3 overflow-hidden" style="border-right: 3px solid #ddd; margin-top: 0.3rem;">
                    <div class="widget widget-categories">
                        <div class="position-relative w-100 mb-2 custom-wrapping">
                            <h4>{{ course.name }}</h4>
                            <hr style="opacity: 0.25; height: 3px;" />
                            <ul>
                                <!-- Course pre quiz -->
                                <li v-if="course.pre_quiz && course.pre_quiz.questions.length && course.pre_quiz_enabled" class="mb-0">
                                    <h4 class="pointer" :class="{ 'text-primary': isQuizSelected('pre', null) }" @click="selectQuiz('pre', null)">
                                        <i class="fas fa-question-circle fs-6 me-1" :style="{'color': course.pre_quiz_completed ? '#198754' : '#4a4b65'}"></i> Course Pre Quiz
                                    </h4>
                                </li>
                                <!-- Modules with their quizzes -->
                                <li v-for="module in course.modules" :key="module.id" class="mb-0"
                                :style="{ cursor: course.pre_quiz && !course.pre_quiz_completed && !course.is_mine ? 'not-allowed' : 'pointer' }">
                                    <!-- Module pre quiz -->
                                    <h4 v-if="module.pre_quiz && module.pre_quiz.questions && module.pre_quiz.questions.length && module.pre_quiz_enabled"
                                        :class="{ 'text-primary': isQuizSelected('pre', module.id) }"
                                        :style="{
                                            'pointer-events': module.pre_quiz_completed || isModulePreQuizAccessible(module.id) ? 'auto' : 'none',
                                            'opacity': module.pre_quiz_completed || isModulePreQuizAccessible(module.id) ? '1' : '0.6',
                                            'cursor': module.pre_quiz_completed || isModulePreQuizAccessible(module.id) ? 'pointer' : 'not-allowed'
                                        }"
                                        @click="selectQuiz('pre', module.id)">
                                        <i class="fas fa-question-circle fs-6 me-1" :style="{'color': module.pre_quiz_completed ? '#198754' : '#4a4b65'}"></i>
                                        {{ module.title }} Pre Quiz
                                    </h4>
                                    <!-- Module title and lessons -->
                                    <h4
                                        :class="{ 'text-primary': isModuleSelected(module.id) }"
                                        :style="{
                                            'pointer-events': isModuleAccessible(module.id) ? 'auto' : 'none',
                                            'opacity': isModuleAccessible(module.id) ? '1' : '0.6',
                                            'cursor': isModuleAccessible(module.id) ? 'pointer' : 'not-allowed'
                                        }"
                                        @click="toggleModule(module.id)">
                                        <i
                                        :class="{
                                            'fas fa-caret-down': !collapsedModules[module.id],
                                            'fas fa-caret-right': collapsedModules[module.id],
                                        }"
                                        style="margin-right: 10px;"
                                        :style="{ 'margin-left': collapsedModules[module.id] ? '0px' : '2px' }"
                                        ></i>
                                        {{ module.title }}
                                        <i v-if="module.description" 
                                            class="fa-solid fa-circle-info pointer text-primary" 
                                            aria-label="View module description"
                                            @click.stop="showModuleDescription(module)"></i>
                                        <!--<span v-if="!isModuleAccessible(module.id)" class="ms-2 fs-6 text-muted">
                                            (Complete previous modules first)
                                        </span>-->
                                    </h4>
                                    <!-- Module lessons -->
                                    <ul v-show="!collapsedModules[module.id]">
                                        <li v-for="item in module.items" :key="item.id">
                                            <a
                                                :style="{
                                                    'pointer-events': isModuleAccessible(module.id) ? 'auto' : 'none',
                                                    'opacity': isModuleAccessible(module.id) ? '1' : '0.6',
                                                    'cursor': isModuleAccessible(module.id) ? 'pointer' : 'not-allowed'
                                                }"
                                                @click="isModuleAccessible(module.id) ? selectMedia(item.slug) : null">
                                                <h5 class="pointer" 
                                                    :class="{ 'text-primary': isItemSelected(item.slug) }">
                                                    <i class="fa-solid" :class="item.completed ? 'fa-circle-check text-success' : 'fa-circle-video'"></i>&nbsp;
                                                    {{ item.title }}
                                                </h5>
                                            </a>
                                        </li>
                                    </ul>
                                    <!-- Module post quiz -->
                                    <h4 v-if="module.post_quiz && module.post_quiz.questions && module.post_quiz.questions.length && module.post_quiz_enabled"
                                        :class="{ 'text-primary': isQuizSelected('post', module.id) }"
                                        :style="{
                                            'pointer-events': (module.post_quiz_completed || (moduleAllItemsCompleted(module) && (!module.pre_quiz_enabled || module.pre_quiz_completed))) || course.is_mine ? 'auto' : 'none',
                                            'opacity': (module.post_quiz_completed || (moduleAllItemsCompleted(module) && (!module.pre_quiz_enabled || module.pre_quiz_completed))) || course.is_mine ? '1' : '0.6',
                                            'cursor': (module.post_quiz_completed || (moduleAllItemsCompleted(module) && (!module.pre_quiz_enabled || module.pre_quiz_completed))) || course.is_mine ? 'pointer' : 'not-allowed'
                                        }"
                                        @click="selectQuiz('post', module.id)">
                                        <i class="fas fa-question-circle fs-6 me-1" :style="{'color': module.post_quiz_completed ? '#198754' : '#4a4b65'}"></i>
                                        {{ module.title }} Post Quiz
                                    </h4>
                                </li>
                                <!-- Course post quiz -->
                                <li v-if="course.post_quiz && course.post_quiz.questions.length && course.post_quiz_enabled"
                                    :style="{ cursor: (course.completion_percentage === 100 && allModuleQuizzesCompleted && (!course.pre_quiz_enabled || course.pre_quiz_completed)) || course.is_mine ? 'pointer' : 'not-allowed' }">
                                    <h4
                                        :class="{ 'text-primary': isQuizSelected('post', null) }"
                                        :style="{
                                            'pointer-events': (course.post_quiz_completed || (course.completion_percentage >= 100 && allModuleQuizzesCompleted && (!course.pre_quiz_enabled || course.pre_quiz_completed))) || course.is_mine ? 'auto' : 'none',
                                            'opacity': (course.post_quiz_completed || (course.completion_percentage >= 100 && allModuleQuizzesCompleted && (!course.pre_quiz_enabled || course.pre_quiz_completed))) || course.is_mine ? '1' : '0.6',
                                            'cursor': (course.post_quiz_completed || (course.completion_percentage >= 100 && allModuleQuizzesCompleted && (!course.pre_quiz_enabled || course.pre_quiz_completed))) || course.is_mine ? 'pointer' : 'not-allowed'
                                        }"
                                        @click="selectQuiz('post', null)"
                                    >
                                        <i class="fas fa-question-circle fs-6 me-1" :style="{'color': course.post_quiz_completed ? '#198754' : '#4a4b65'}"></i> Course Post Quiz
                                    </h4>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-9">
                    <div class="row pb-2">
                        <!-- Breadcrumbs -->
                        <div class="col-8 p-0">
                            <nav aria-label="breadcrumb">
                                <ul class="py-1 my-2 breadcrumb">
                                    <li class="breadcrumb-item">
                                        <a href="/courses" class="text-secondary fw-bold">
                                            {{ $t('nav.courses') }}
                                        </a>
                                    </li>
                                    <li class="breadcrumb-item">
                                        <a :href="'/courses/preview/' + course.slug" class="text-primary fw-bold">
                                            {{ course.name }}
                                        </a>
                                    </li>
                                    <li class="breadcrumb-item">
                                        <a class="text-primary fw-bold">
                                            {{ $t('view-course') }}
                                        </a>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div class="col-4 text-end mt-1">
                            <div v-if="selected_media_slug" class="d-flex justify-content-end">
                                <button v-if="!isFirstMediaItem" class="btn btn-outline-primary custom-padding me-2" style="border: 2px solid;" @click="previousLesson">
                                    {{ $t('previous-lesson') }}
                                </button>
                                <button class="btn btn-primary custom-padding" @click="completeAndContinue">
                                    {{ $t('complete-and-continue') }}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div style="padding-left: 11px;">
                        <h5 v-if="((!course.pre_quiz || course.pre_quiz_completed || !course.pre_quiz_enabled) && !selected_media_slug && !selected_quiz) || course.is_mine">
                            {{ $t('select-an-item-on-the-left-to-view-its-content') }}
                        </h5>
                    </div>
                    <!-- Quiz component with conditional rendering based on whether it's a course or module quiz -->
                    <div v-if="selected_quiz">
                        <Quiz 
                            v-if="selected_module_id == null" 
                            :quiz="selected_quiz === 'pre' ? course.pre_quiz : course.post_quiz" 
                            :type="selected_quiz" 
                            :course_id="course.id" 
                            :is_mine="course.is_mine"
                            :results="selected_quiz === 'pre' ? course.pre_quiz_results : course.post_quiz_results"
                            @quiz-completed="quizCompleted" 
                        />
                        <Quiz 
                            v-else 
                            :quiz="getModuleQuiz(selected_module_id, selected_quiz)" 
                            :type="selected_quiz" 
                            :course_id="course.id" 
                            :module_id="selected_module_id"
                            :is_mine="course.is_mine"
                            :results="getModuleQuizResults(selected_module_id, selected_quiz)"
                            @quiz-completed="moduleQuizCompleted" 
                        />
                    </div>
                    <MediaSection v-if="selected_media_slug" :media_slug="selected_media_slug" :inCourse="true" />
                    <div class="row">
                        <div class="col-12 text-end">
                            <div v-if="selected_media_slug" class="d-flex justify-content-end">
                                <button v-if="!isFirstMediaItem" class="btn btn-outline-primary custom-padding me-2" style="border: 2px solid;" @click="previousLesson">
                                    {{ $t('previous-lesson') }}
                                </button>
                                <button class="btn btn-primary custom-padding" @click="completeAndContinue">
                                    {{ $t('complete-and-continue') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr style="opacity: 0.25; height: 2px; margin-left: 15px; margin-right: 15px;" />
        </div>
        <div v-if="busy" class="text-center" style="padding-top: 11rem;">
            <i class="fas fa-5x fa-spinner"></i>
        </div>
        <b-modal v-model="isModuleDescriptionModalOpen" hide-footer hide-header centered size="md">
            <div class="p-2">
                <h4>{{ selectedModule?.title }}</h4>
                <div class="mt-3" v-html="selectedModule?.description"></div>
            </div>
        </b-modal>
    </DefaultLayout>
</template>
<script>
import MediaSection from '@/components/commons/Media/Section.vue';
import Quiz from './Quiz.vue';
import DefaultLayout from '@/views/layouts/default/';

export default {
    components: {
        MediaSection,
        Quiz,
        DefaultLayout,
    },
    props: {
        course_slug: {
            type: String,
            default: null,
        },
        selected_item_slug: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            busy: true,
            course: null,
            collapsedModules: {},
            selected_media_slug: null,
            selected_quiz: null,
            selected_module_id: null,
            isModuleDescriptionModalOpen: false,
            selectedModule: null,
        };
    },
    computed: {
        allModuleQuizzesCompleted() {
            if (!this.course || !this.course.modules) return false;
            return this.course.modules.every(module => {
                const preQuizCompleted = !module.pre_quiz_enabled || module.pre_quiz_completed;
                const postQuizCompleted = !module.post_quiz_enabled || module.post_quiz_completed;
                return preQuizCompleted && postQuizCompleted;
            });
        },
        isFirstMediaItem() {
            if (!this.selected_media_slug || !this.course || !this.course.modules.length) return false;
            const firstModule = this.course.modules[0];
            return firstModule.items.length && firstModule.items[0].slug === this.selected_media_slug;
        },
    },
    mounted() {
        this.load();
    },
    methods: {
        load() {
            if (!this.$auth.auth) {
                this.$bus.emit('show-sign-in', this.$route.fullPath, 'Please sign in to view this course.');
                return;
            }
            this.$http.get('courses/' + this.course_slug).then((resp) => {
                this.course = resp.data;
                // make sure module items are sorted by position
                this.course.modules.forEach((module) => {
                    module.items.sort((a, b) => a.position - b.position);
                });
                // initialize collapsed state for each module with all collapsed
                this.collapsedModules = this.course.modules.reduce((acc, module) => {
                    acc[module.id] = true;
                    return acc;
                }, {});
                if (!this.course.is_mine && !this.course.is_enrolled) {
                    this.$swal.fire({
                        icon: 'warning',
                        title: 'Unauthorized access',
                        text: 'You are not enrolled in this course. Please enroll first to access the content.',
                        confirmButtonText: 'View course details',
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                    }).then(() => {
                        this.$router.push(`/courses/preview/${this.course.slug}`);
                    });
                    return;
                }
                if ((this.course.pre_quiz && !this.course.pre_quiz_completed && this.course.pre_quiz_enabled) && !this.selected_quiz) {
                    if (this.selected_item_slug) {
                        const module = this.course.modules.find(module => 
                            module.items.some(item => item.slug === this.selected_item_slug)
                        );
                        if (module) {
                            // expand the module containing the selected item
                            this.$set(this.collapsedModules, module.id, false);
                        }
                        this.selectMedia(this.selected_item_slug);
                    } else {
                        if (!this.course.is_mine) {
                            this.selectQuiz('pre');
                        }
                    }
                }
                this.busy = false;
            }).catch((error) => {
                if (error && error.status === 404) {
                    this.$router.push('/404');
                } else {
                    console.log('Error:', error.message);
                    this.busy = false;
                }
            });
        },
        toggleModule(moduleId) {
            // only allow toggling if the module is accessible
            if (this.isModuleAccessible(moduleId) || this.course.is_mine) {
                this.$set(this.collapsedModules, moduleId, !this.collapsedModules[moduleId]);
            } else {
                this.$swal.fire({
                    icon: 'warning',
                    title: 'Access Restricted',
                    text: 'Please complete the previous modules before accessing this content.',
                });
            }
        },
        isModulePreQuizAccessible(moduleId) {
            if (this.course.is_mine) {
                return true; // course owner can access everything
            }

            // check if course pre-quiz is completed if it exists
            if (this.course.pre_quiz && this.course.pre_quiz_enabled && !this.course.pre_quiz_completed) {
                return false;
            }

            // find the index of the current module
            const moduleIndex = this.course.modules.findIndex(m => m.id === moduleId);
            if (moduleIndex === 0) {
                // first module's pre-quiz is accessible as long as course pre-quiz is completed
                return true;
            }

            // check all previous modules - if any are incomplete, block access
            for (let i = 0; i < moduleIndex; i++) {
                const prevModule = this.course.modules[i];

                // if previous module has a post-quiz that's not completed, block access
                if (prevModule.post_quiz && prevModule.post_quiz_enabled && !prevModule.post_quiz_completed) {
                    return false;
                }

                // check if all items in the previous module are completed
                if (!this.moduleAllItemsCompleted(prevModule)) {
                    return false;
                }
            }
            return true;
        },
        isModuleAccessible(moduleId) {
            if (this.course.is_mine) {
                return true; // course owner can access everything
            }

            // first check if course pre-quiz is completed if it exists
            if (this.course.pre_quiz && this.course.pre_quiz_enabled && !this.course.pre_quiz_completed) {
                return false;
            }

            // get the current module
            const module = this.course.modules.find(m => m.id === moduleId);
            if (!module) return false;

            // if this module has a pre-quiz that's not completed, block access
            if (module.pre_quiz && module.pre_quiz_enabled && !module.pre_quiz_completed) {
                return false;
            }

            // find the index of the current module
            const moduleIndex = this.course.modules.findIndex(m => m.id === moduleId);
            if (moduleIndex === 0) {
                // first module is accessible as long as course pre-quiz is completed
                // AND module's own pre-quiz is completed (already checked above)
                return true;
            }

            // check all previous modules - if any have incomplete post-quizzes, block access
            for (let i = 0; i < moduleIndex; i++) {
                const prevModule = this.course.modules[i];

                // if previous module has a post-quiz that's not completed, block access
                if (prevModule.post_quiz && prevModule.post_quiz_enabled && !prevModule.post_quiz_completed) {
                    return false;
                }

                // also check if all items in the previous module are completed
                if (!this.moduleAllItemsCompleted(prevModule)) {
                    return false;
                }
            }
            return true;
        },
        showModuleDescription(module) {
            this.selectedModule = module;
            this.isModuleDescriptionModalOpen = true;
        },
        selectMedia(slug) {
            // check if the module containing this item is accessible
            const module = this.course.modules.find(m => 
                m.items.some(item => item.slug === slug)
            );

            if (module && !this.isModuleAccessible(module.id) && !this.course.is_mine) {
                this.$swal.fire({
                    icon: 'warning',
                    title: 'Access Restricted',
                    text: 'Please complete the previous modules before accessing this content.',
                });
                return;
            }

            this.selected_media_slug = slug;
            this.selected_quiz = null; // deselect quiz when media is selected
        },
        selectQuiz(type, moduleId) {
            this.selected_quiz = type;
            this.selected_module_id = moduleId;
            this.selected_media_slug = null; // deselect media when quiz is selected
        },
        checkCourseCompletion() {
            const allModulesCompleted = this.course.modules.every(module => {
                const allItemsCompleted = this.moduleAllItemsCompleted(module);
                const preQuizCompleted = !module.pre_quiz_enabled || module.pre_quiz_completed;
                const postQuizCompleted = !module.post_quiz_enabled || module.post_quiz_completed;
                return allItemsCompleted && preQuizCompleted && postQuizCompleted;
            });

            const coursePreQuizCompleted = !this.course.pre_quiz_enabled || this.course.pre_quiz_completed;
            const coursePostQuizCompleted = !this.course.post_quiz_enabled || this.course.post_quiz_completed;

            if (allModulesCompleted && coursePreQuizCompleted && !coursePostQuizCompleted && this.course.post_quiz_enabled) {
                // if everything is completed except the course post quiz, select it
                this.selectQuiz('post', null);
            } else if (allModulesCompleted && coursePreQuizCompleted && coursePostQuizCompleted) {
                // everything is completed
                this.$swal.fire({
                    icon: 'success',
                    title: 'Congratulations!',
                    text: 'You have successfully completed the entire course.',
                }).then(() => {
                    this.$router.push('/courses');
                });
            }
        },
        refreshCourseData() {
            const currentState = {
                selected_media_slug: this.selected_media_slug,
                selected_quiz: this.selected_quiz,
                selected_module_id: this.selected_module_id,
                collapsedModulesState: {...this.collapsedModules}
            };

            this.busy = true;

            // return the promise so we can chain actions after refresh completes
            return this.$http.get('courses/' + this.course_slug)
                .then((resp) => {
                    this.course = resp.data;

                    // sort module items by position
                    this.course.modules.forEach((module) => {
                        module.items.sort((a, b) => a.position - b.position);
                    });

                    // restore view state
                    this.selected_media_slug = currentState.selected_media_slug;
                    this.selected_quiz = currentState.selected_quiz;
                    this.selected_module_id = currentState.selected_module_id;

                    // restore module collapsed states
                    this.collapsedModules = this.course.modules.reduce((acc, module) => {
                        acc[module.id] = currentState.collapsedModulesState[module.id] !== undefined 
                            ? currentState.collapsedModulesState[module.id] 
                            : true;
                        return acc;
                    }, {});

                    this.busy = false;
                    return resp.data; // return the refreshed course data
                })
                .catch(error => {
                    console.error('Error refreshing course data:', error);
                    this.busy = false;
                    throw error; // re-throw so error can be caught by caller
                });
        },
        isModuleSelected(moduleId) {
            if (!this.selected_media_slug) return false;
            const module = this.course.modules.find(module => module.id === moduleId);
            return module.items.some(item => item.slug === this.selected_media_slug);
        },
        isItemSelected(slug) {
            return this.selected_media_slug === slug;
        },
        isQuizSelected(type, moduleId) {
            return this.selected_quiz === type && this.selected_module_id === moduleId;
        },
        getModuleQuiz(moduleId, quizType) {
            const module = this.course.modules.find(m => m.id === moduleId);
            if (!module) return null;
            return quizType === 'pre' ? module.pre_quiz : module.post_quiz;
        },
        getModuleQuizResults(moduleId, quizType) {
            const module = this.course.modules.find(m => m.id === moduleId);
            if (!module) return null;
            return quizType === 'pre' ? module.pre_quiz_results : module.post_quiz_results;
        },
        moduleCompletionPercentage(module) {
            if (!module.items || module.items.length === 0) return 100;
            const completedItems = module.items.filter(item => item.completed).length;
            return (completedItems / module.items.length) * 100;
        },
        moduleAllItemsCompleted(module) {
            if (!module.items || module.items.length === 0) return true;
            return module.items.every(item => item.completed);
        },
        findNextContent() {
            // if course pre-quiz isn't completed and exists, that's first
            if (this.course.pre_quiz && !this.course.pre_quiz_completed && this.course.pre_quiz_enabled) {
                return { type: 'quiz', quiz_type: 'pre', module_id: null };
            }

            // then check modules in order
            for (let i = 0; i < this.course.modules.length; i++) {
                const module = this.course.modules[i];

                // if module pre-quiz exists and isn't completed, that's next
                if (module.pre_quiz && !module.pre_quiz_completed && module.pre_quiz_enabled) {
                    return { type: 'quiz', quiz_type: 'pre', module_id: module.id };
                }

                // check each item in the module
                for (let j = 0; j < module.items.length; j++) {
                    if (!module.items[j].completed) {
                        return { type: 'item', item_slug: module.items[j].slug };
                    }
                }

                // if module post-quiz exists and isn't completed, that's next
                if (module.post_quiz && !module.post_quiz_completed && module.post_quiz_enabled) {
                    return { type: 'quiz', quiz_type: 'post', module_id: module.id };
                }
            }

            // finally, if course post-quiz exists and isn't completed, that's last
            if (this.course.post_quiz && !this.course.post_quiz_completed && this.course.post_quiz_enabled) {
                return { type: 'quiz', quiz_type: 'post', module_id: null };
            }

            // everything is completed
            return { type: 'completed' };
        },
        findNextModuleContent(moduleId) {
            const moduleIndex = this.course.modules.findIndex(m => m.id === moduleId);
            if (moduleIndex === -1) return null;

            // first check if the current module has a post quiz
            const currentModule = this.course.modules[moduleIndex];
            if (currentModule.post_quiz && !currentModule.post_quiz_completed && currentModule.post_quiz_enabled) {
                return { type: 'quiz', quiz_type: 'post', module_id: moduleId };
            }

            // If there are more modules, check the next one
            if (moduleIndex < this.course.modules.length - 1) {
                const nextModule = this.course.modules[moduleIndex + 1];

                // check if next module has a pre quiz
                if (nextModule.pre_quiz && !nextModule.pre_quiz_completed && nextModule.pre_quiz_enabled) {
                    return { type: 'quiz', quiz_type: 'pre', module_id: nextModule.id };
                }

                // otherwise go to first item of the next module
                if (nextModule.items.length > 0) {
                    return { type: 'item', item_slug: nextModule.items[0].slug };
                }
            }

            // if we've completed all modules, go to course post quiz
            if (this.course.post_quiz && !this.course.post_quiz_completed && this.course.post_quiz_enabled) {
                return { type: 'quiz', quiz_type: 'post', module_id: null };
            }

            // everything is completed
            return { type: 'completed' };
        },
        navigateToContent(contentInfo) {
            if (!contentInfo) return;

            if (contentInfo.type === 'quiz') {
                this.selectQuiz(contentInfo.quiz_type, contentInfo.module_id);

                // expand module if it's a module quiz
                if (contentInfo.module_id) {
                    this.$set(this.collapsedModules, contentInfo.module_id, false);
                }
            } 
            else if (contentInfo.type === 'item') {
                this.selected_quiz = null;
                this.selected_module_id = null;
                this.selected_media_slug = contentInfo.item_slug;

                // find and expand the module containing this item
                const module = this.course.modules.find(m => 
                    m.items.some(item => item.slug === contentInfo.item_slug)
                );
                if (module) {
                    this.$set(this.collapsedModules, module.id, false);
                }
            }
            else if (contentInfo.type === 'completed') {
                // everything is completed
                this.$swal.fire({
                    icon: 'success',
                    title: 'Congratulations!',
                    text: 'You have successfully completed the entire course.',
                }).then(() => {
                    this.$router.push('/courses');
                });
            }
        },
        previousLesson() {
            let found = false;
            for (let i = 0; i < this.course.modules.length; i++) {
                const module = this.course.modules[i];
                for (let j = 0; j < module.items.length; j++) {
                    if (module.items[j].slug === this.selected_media_slug) {
                        if (j > 0) {
                            this.selected_media_slug = module.items[j - 1].slug;
                        } else if (i > 0) {
                            const previousModule = this.course.modules[i - 1];
                            this.selected_media_slug = previousModule.items[previousModule.items.length - 1].slug;
                            // collapse current module and expand previous module
                            this.$set(this.collapsedModules, module.id, true);
                            this.$set(this.collapsedModules, previousModule.id, false);
                        }
                        found = true;
                        break;
                    }
                }
                if (found) break;
            }
        },
        completeAndContinue() {
            let found = false;
            for (let i = 0; i < this.course.modules.length; i++) {
                const module = this.course.modules[i];
                for (let j = 0; j < module.items.length; j++) {
                    if (module.items[j].slug === this.selected_media_slug) {
                        this.$http.post(`courses/mark-item-complete/${module.items[j].id}`).then(resp => {
                            this.course.completion_percentage = resp.data.completion_percentage;
                            module.items[j].completed = true;

                            if (j < module.items.length - 1) {
                                // if not the last item in module, go to next item
                                this.selected_media_slug = module.items[j + 1].slug;
                            } else {
                                // this is the last item in the module
                                // check if module has a post-quiz
                                if (module.post_quiz && module.post_quiz.questions && 
                                    module.post_quiz.questions.length && module.post_quiz_enabled && 
                                    !module.post_quiz_completed && (!module.pre_quiz_enabled || module.pre_quiz_completed)) {
                                    // go to module post-quiz
                                    this.selectQuiz('post', module.id);
                                } else if (i < this.course.modules.length - 1) {
                                    // no module post-quiz, go to next module
                                    const nextModule = this.course.modules[i + 1];

                                    // check if next module has a pre-quiz
                                    if (nextModule.pre_quiz && nextModule.pre_quiz.questions && 
                                        nextModule.pre_quiz.questions.length && nextModule.pre_quiz_enabled && 
                                        !nextModule.pre_quiz_completed) {
                                        // go to next module's pre-quiz
                                        this.selectQuiz('pre', nextModule.id);
                                    } else {
                                        // go to first item of next module
                                        this.selected_media_slug = nextModule.items[0].slug;

                                        // collapse current module and expand next module
                                        this.$set(this.collapsedModules, module.id, true);
                                        this.$set(this.collapsedModules, nextModule.id, false);
                                    }
                                } else {
                                    // last module, last item
                                    // check for course post-quiz
                                    if (this.course.post_quiz && this.course.post_quiz.questions.length && 
                                        this.course.post_quiz_enabled && !this.course.post_quiz_completed && 
                                        this.allModuleQuizzesCompleted &&
                                        (!this.course.pre_quiz_enabled || this.course.pre_quiz_completed)) {
                                        this.selectQuiz('post', null);
                                    } else {
                                        // course completed
                                        this.$swal.fire({
                                            icon: 'success',
                                            title: 'Congratulations!',
                                            text: 'You have successfully completed the course.',
                                        }).then(() => {
                                            this.$router.push('/courses');
                                        });
                                    }
                                }
                            }
                        })
                        .catch(error => {
                            console.error('Error marking item as complete:', error);
                        });
                        found = true;
                        break;
                    }
                }
                if (found) break;
            }
        },
        quizCompleted(type) {
            if (type === 'pre') {
                this.$http.post(`quiz/complete/${this.course_slug}`, { pre_quiz_completed: true })
                    .then(() => {
                        // refresh course data before updating local state and navigating
                        return this.refreshCourseData(); 
                    })
                    .then(() => {
                        // find next content to navigate to using the refreshed data
                        const nextContent = this.findNextContent();
                        this.navigateToContent(nextContent);
                    })
                    .catch(error => {
                        console.error('Error marking pre quiz as completed:', error);
                    });
            } else if (type === 'post') {
                this.$http.post(`quiz/complete/${this.course_slug}`, { post_quiz_completed: true })
                    .then(() => {
                        // refresh course data before updating local state
                        return this.refreshCourseData();
                    })
                    .then(() => {
                        this.selected_quiz = null;
                        this.$swal.fire({
                            icon: 'success',
                            title: 'Congratulations!',
                            text: 'You have successfully completed the course.',
                        }).then(() => {
                            this.$router.push('/courses');
                        });
                    })
                    .catch(error => {
                        console.error('Error marking post quiz as completed:', error);
                    });
            }
        },
        moduleQuizCompleted(type) {
            const moduleId = this.selected_module_id;
            if (!moduleId) return;

            this.$http.post(`quiz/module-complete/${this.course_slug}`, {
                module_id: moduleId,
                pre_quiz_completed: type === 'pre',
                post_quiz_completed: type === 'post'
            })
            .then(() => {
                // first refresh course data to get updated quiz results
                return this.refreshCourseData();
            })
            .then(refreshedCourse => {
                // find the module in the refreshed course data
                const module = refreshedCourse.modules.find(m => m.id === moduleId);
                if (!module) return;

                if (type === 'pre') {
                    // if module has items, go to the first item
                    if (module.items.length > 0) {
                        this.selected_quiz = null;
                        this.selected_module_id = null;
                        this.selected_media_slug = module.items[0].slug;
                        this.$set(this.collapsedModules, moduleId, false); // expand module
                    } else {
                        // if no items, check for post quiz or next module
                        const nextContent = this.findNextModuleContent(moduleId);
                        this.navigateToContent(nextContent);
                    }
                } else if (type === 'post') {
                    // navigate to next content
                    const moduleIndex = refreshedCourse.modules.findIndex(m => m.id === moduleId);
                    if (moduleIndex < refreshedCourse.modules.length - 1) {
                        const nextModule = refreshedCourse.modules[moduleIndex + 1];

                        if (nextModule.pre_quiz && nextModule.pre_quiz_enabled && !nextModule.pre_quiz_completed) {
                            // go to next module's pre-quiz
                            this.selectQuiz('pre', nextModule.id);
                        } else if (nextModule.items.length > 0) {
                            // go to next module's first item
                            this.selected_quiz = null;
                            this.selected_module_id = null;
                            this.selected_media_slug = nextModule.items[0].slug;

                            // expand next module, collapse current
                            this.$set(this.collapsedModules, moduleId, true);
                            this.$set(this.collapsedModules, nextModule.id, false);
                        }
                    } else {
                        // if it was the last module, check if there's a course post-quiz
                        if (refreshedCourse.post_quiz && refreshedCourse.post_quiz_enabled && !refreshedCourse.post_quiz_completed) {
                            this.selectQuiz('post', null);
                        } else {
                            // course completed
                            this.$swal.fire({
                                icon: 'success',
                                title: 'Congratulations!',
                                text: 'You have successfully completed the course.',
                            }).then(() => {
                                this.$router.push('/courses');
                            });
                        }
                    }
                }
            })
            .catch(error => {
                console.error('Error marking module quiz as completed:', error);
            });
        },
    },
};
</script>
<style scoped>
li h4, li a {
    display: block;
    padding-left: 10px;
    margin: 0;
    line-height: 1.5;
}
ul {
    list-style: none;
    padding: 0;
    margin: 0;
}
ul ul {
    margin-left: 10px;
}
.custom-wrapping {
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
}
h4 {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
h4 i {
    transition: transform 0.3s ease;
}
h4 i.fas.fa-caret-right {
    transform: rotate(360deg);
}
.breadcrumb {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.breadcrumb-item {
    display: inline-block;
    max-width: 100%;
}
.breadcrumb-item a {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.custom-padding {
    padding: 0.425rem 1.7rem !important;
}
</style>